export default function LinkExpiredPage() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg)' }}>
      <div className="text-center max-w-md">
        <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 24, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>
          This link has expired
        </h1>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: 14, color: 'var(--text-secondary)', marginBottom: 24 }}>
          Approval links are valid for 7 days and can only be used once.
          Contact your delivery manager to request a fresh link.
        </p>
        <a
          href="/login"
          style={{ fontFamily: 'var(--font-body)', fontSize: 14, color: '#8b5cf6' }}
          className="hover:underline"
        >
          Sign in to your account &rarr;
        </a>
      </div>
    </div>
  );
}
